import { render } from "./LoginScreen.vue?vue&type=template&id=506bfd5e&scoped=true"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"

import "./LoginScreen.vue?vue&type=style&index=0&id=506bfd5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506bfd5e"]])

export default __exports__